<template>
  <cus-order-dialog>
    <template v-slot:body>
      <div class="button-wrap">
        <cus-button text="交班清帳" topIcon="clipboard-check" topIconClass="big-top" @click="handleShift"></cus-button>
        <cus-button
          text="日結報表"
          topIcon="card-list"
          topIconClass="big-top"
          @click="openOrderDialog('dailyRecord')"
        ></cus-button>
        <cus-button text="登出" topIcon="box-arrow-right" topIconClass="big-top" @click="logout"></cus-button>
        <div class="notification-btn-wrap">
          <div v-if="getCount.notification_unread_count > 0" class="dot"></div>
          <cus-button
            text="訊息通知"
            topIcon="chat-right-text"
            topIconClass="big-top"
            @click="openOrderDialog('notification')"
          ></cus-button>
        </div>
        <div class="update-btn-wrap">
          <div v-if="getSoftwareStatus === 3" class="dot"></div>
          <cus-button
            text="更新"
            topIcon="arrow-clockwise"
            topIconClass="big-top"
            @click="openInnerDialog('updating')"
          ></cus-button>
        </div>
        <cus-button text="設定" topIcon="gear" topIconClass="big-top" @click="openInnerDialog('setting')"></cus-button>
        <small class="version">version: {{ getVersion }}</small>
      </div>
    </template>
    <template v-slot:footer>
      <cus-button text="關閉" color="blue" @click="close" style="padding: 0"></cus-button>
    </template>
  </cus-order-dialog>

  <!-- 各式彈窗 -->
  <component :is="inner_dialogTemplate"></component>
</template>
<script>
import { inject, getCurrentInstance, defineAsyncComponent } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { useDialogInDialog } from '@/utils/dialog';
export default {
  name: 'manage-action',
  components: {
    Setting: defineAsyncComponent(() => import('@/components/orderDialog/Setting.vue')),
    Updating: defineAsyncComponent(() => import('@/components/orderDialog/Updating.vue')),
  },
  setup() {
    const { proxy } = getCurrentInstance();
    const { inner_dialogTemplate, openInnerDialog } = useDialogInDialog();
    //接受provide值
    const close = inject('order_close');
    const submit = inject('order_submit');
    const openOrderDialog = inject('openOrderDialog');
    //取得版號/未讀數量/軟體狀態
    const { getVersion, getCount } = useGetters('system', ['getVersion', 'getCount']);
    const getEcho = useActions('system', ['getEcho']);
    const checkSoftwareStatus = useActions('upgrade', ['checkSoftwareStatus']);
    const init = (function () {
      getEcho();
      checkSoftwareStatus();
    })();

    //交班清帳
    const handleShift = () => {
      if (getCount.value.pending_order_count || getCount.value.wait_write_off_order_count) {
        proxy.$message('錯誤提示', '尚有未結帳/未沖銷訂單，無法結帳').catch((e) => e);
      } else {
        openOrderDialog('shift');
      }
    };

    //登出
    const doLogout = useActions('system', ['doLogout']);
    const logout = () => {
      proxy
        .$confirm({
          content: `尚未交班清帳，是否確定要登出？`,
          confirmText: '登出',
        })
        .then(() => {
          doLogout();
        })
        .catch((e) => e);
    };

    //軟體更新
    const getSoftwareStatus = useGetters('upgrade', ['getSoftwareStatus']);

    return {
      close,
      submit,
      openOrderDialog,
      inner_dialogTemplate,
      openInnerDialog,
      getVersion,
      getCount,
      init,
      handleShift,
      logout,
      getSoftwareStatus,
    };
  },
};
</script>
<style lang="scss" scoped>
.button-wrap {
  position: relative;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 120px);
  grid-gap: 8px;
  margin-bottom: 20px;
}

.notification-btn-wrap,
.update-btn-wrap {
  display: flex;
  position: relative;
  .dot {
    position: absolute;
    top: 12px;
    right: 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: $color-yellow;
  }
}
.version {
  position: absolute;
  bottom: -25px;
  right: 4px;
}
</style>
